import { LearningObject } from "@app/common/models/learning-object";

export class SectionCompleteStatus extends LearningObject {
    isCompleted: boolean;
  }